import { render } from "./ManageCodesGroupsModal.vue?vue&type=template&id=4f02546c"
import script from "./ManageCodesGroupsModal.vue?vue&type=script&lang=js"
export * from "./ManageCodesGroupsModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__